import { isSelectionInColumn } from '@lumapps/wrex-columns/utils/isSelectionInColumn';
import { Editor } from '@lumapps/wrex/slate';

export const isListAllowed = (editor: Editor) => (): boolean => {
    const isInColumn = isSelectionInColumn(editor);
    return !isInColumn;
};
